export default "__VITE_ASSET__BEmzsOXC__"